import { Button } from "antd";
import React from "react";
export default class FeedbackListCellButton extends React.Component {

  render() {
    let buttonPrefixText = "";
    
    return (
      <a onClick={() => this.props.cellLinkButtonClick(this.props.data)} style={{cursor:"pointer",color:"blue"}}>
        {this.props.value}
      </a>
    )
  }
}
